import './styles.css';

const InternalContainer = ({ children, className = '' }) => {
	return (
		<div className={`intern-container-component__olib ${className}`}>{children}</div>
	);
};

export default InternalContainer;
